import type React from "react"

import imgDefault from "../assets/imgEditPerfil/user.png"
import {
  faEnvelope,
  faPhone,
  faLocationDot,
  faChartLine,
  faBars,
  faCrown,
  faChevronDown,
  faCreditCard,
  faCheckToSlot,
  faClockRotateLeft,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFacebookSquare, faInstagramSquare, faTwitterSquare, faLinkedin } from "@fortawesome/free-brands-svg-icons"
import { Link } from "react-router-dom"
import type { UpdatedInfoCompany } from "../Interfaces/Company"
import { useEffect, useState } from "react"
import axios from "axios"
import Cookies from "universal-cookie"
import CompanySkeleton from "../components/Skeleton/ProfileCompany/companySkeleton"

const initialStateUpdatedInfoCompany = {
  company_name: "",
  company_contact_name: "",
  gmail: "",
  states_id: "",
  country_id: "",
  company_description: "",
  phone: "",
  secondary_phone: "",
  activity_id: "",
  direction: "",
  photo: "",
  Facebook_link: "",
  Instagram_link: "",
  Twitter_link: "",
  Linkedin_link: "",
  id: "",
  email: "",
  plan: "",
  planes_id: "",
  complete_profile_status: 0,
  latitude: 13.692972702987948,
  longitude: -89.23626383096777,
}

const CreacionProfileFreelancer = () => {
  const [InfoCompany, setInfoCompany] = useState<UpdatedInfoCompany>(initialStateUpdatedInfoCompany)
  const [IsLoading, setIsLoading] = useState(true)
  const [ProfileStatus, setProfileStatus] = useState(0)
  const [dropdownOpen, setdropdownOpen] = useState(false)
  const cookies = new Cookies()

  const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    ; (e.target as HTMLImageElement).src = imgDefault
  }

  useEffect(() => {
    async function GetInfoCompany() {
      const idUser = cookies.get("Bearer")
      const urlInfoProfile = `${process.env.REACT_APP_API_URI}company/profile/${idUser.id}`
      const config = {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          ApiToken: `Bearer ${idUser.token}`,
        },
      }

      try {
        const resp = await axios.get(urlInfoProfile, config)
        let imgCompany = ""
        if (resp.data.photo != null) {
          imgCompany = `${process.env.REACT_APP_PHOTO_URI}company-image/${resp.data.photo}`
        } else {
          imgCompany = imgDefault
        }

        let listInfo
        if (typeof resp.data.activity !== "undefined") {
          listInfo = {
            company_name: resp.data.company_name,
            company_contact_name: "",
            gmail: "",
            states_id: resp.data.status,
            country_id: resp.data.country_id,
            company_description: resp.data.company_description,
            phone: resp.data.phone,
            secondary_phone: resp.data.secondary_phone,
            activity_id: resp.data.activity.name,
            direction: resp.data.direction,
            photo: imgCompany,
            Facebook_link: resp.data.Facebook_link,
            Instagram_link: resp.data.Instagram_link,
            Twitter_link: resp.data.Twitter_link,
            Linkedin_link: resp.data.Linkedin_link,
            id: resp.data.user_id,
            email: resp.data.email,
            plan: resp.data.plan,
            planes_id: resp.data.planes_id,
            complete_profile_status: resp.data.complete_profile_status,
            latitude: resp.data.latitude,
            longitude: resp.data.longitude,
          }
        } else {
          listInfo = {
            company_name: resp.data.company_name,
            gmail: "",
            company_contact_name: "",
            states_id: resp.data.status,
            country_id: resp.data.country_id,
            company_description: resp.data.company_description,
            phone: resp.data.phone,
            secondary_phone: resp.data.secondary_phone,
            activity_id: "",
            direction: resp.data.direction,
            photo: imgCompany,
            Facebook_link: resp.data.Facebook_link,
            Instagram_link: resp.data.Instagram_link,
            Twitter_link: resp.data.Twitter_link,
            Linkedin_link: resp.data.Linkedin_link,
            id: resp.data.user_id,
            email: resp.data.email,
            plan: resp.data.plan,
            planes_id: resp.data.planes_id,
            complete_profile_status: resp.data.complete_profile_status,
            latitude: resp.data.latitude,
            longitude: resp.data.longitude,
          }
        }
        setInfoCompany(listInfo)
        setIsLoading(false)
      } catch (err) {
        console.error(err)
      }
    }
    GetInfoCompany()
  }, [])

  return (
    <>
      {IsLoading && <CompanySkeleton />}
      {!IsLoading && (
        <div className="min-h-screen bg-gradient-to-b from-Light-purple via-turquoise to-Dark-purple p-6">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
              <div className="lg:col-span-4">
                <div className="bg-slate-800/50 backdrop-blur-sm rounded-2xl p-8 border border-slate-700/50">
                  <div className="flex flex-col items-center mb-6">
                    <img
                      alt=""
                      src={InfoCompany.photo || "/placeholder.svg"}
                      className="rounded-full w-32 h-32 object-cover border-4 border-slate-600/50 mb-4"
                      onError={handleError}
                    />

                    <div className="flex items-center gap-2 mb-2">
                      <h1 className="text-2xl font-bold text-white text-center">{InfoCompany.company_name}</h1>
                      {/* {InfoCompany.complete_profile_status == 3 && <span className="text-green-400 text-xl">✓</span>} */}
                    </div>

                    <p className="text-slate-400 text-sm mb-4">
                      {InfoCompany.complete_profile_status == 3 && <span className="text-green-400 text-sm">✓ Perfil completo</span>}
                      {InfoCompany.complete_profile_status == 2 && "Perfil incompleto"}
                      {InfoCompany.complete_profile_status == 1 && "En validación"}
                    </p>
                  </div>

                  {InfoCompany.complete_profile_status != 2 && (
                    <div className="mb-8">
                      <p className="text-slate-300 text-sm leading-relaxed text-center">
                        {InfoCompany.company_description}
                      </p>
                    </div>
                  )}

                  <div className="space-y-3">
                    {InfoCompany.complete_profile_status == 3 && (
                      <>
                        <Link
                          to="/proyectos-empresa"
                          className="w-full px-6 py-3 bg-Naranja-Ticongle hover:bg-orange-600 text-white rounded-lg font-medium transition-all duration-200 shadow-lg hover:shadow-xl text-center block"
                        >
                          Ver mis oportunidades
                        </Link>
                        <Link
                          to="/publicar-proyecto"
                          className="w-full px-6 py-3 bg-Azul-Ticongle hover:bg-blue-700 text-white rounded-lg font-medium transition-all duration-200 shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
                        >
                          <span>+</span> Crear oportunidad
                        </Link>
                        <Link
                          to="/Planes"
                          className="relative w-full px-6 py-3 bg-black text-white rounded-lg font-medium shadow-lg flex items-center justify-center gap-2 overflow-hidden"
                        >
                          <span className="shine-effect" />
                          <FontAwesomeIcon icon={faCrown} /> Planes

                          <style>
                            {`
                              .shine-effect {
                                position: absolute;
                                top: 0;
                                left: -75%;
                                height: 100%;
                                width: 50%;
                                background: linear-gradient(
                                  120deg,
                                  transparent,
                                  rgba(255, 255, 255, 0.5),
                                  transparent
                                );
                                transform: skewX(-20deg);
                                animation: shine 2s infinite;
                                pointer-events: none;
                              }

                              @keyframes shine {
                                0% {
                                  left: -75%;
                                }
                                100% {
                                  left: 125%;
                                }
                              }
                            `}
                          </style>
                        </Link>
                      </>
                    )}
                    {InfoCompany.complete_profile_status == 2 && (
                      <Link
                        to="/editar-perfil-empresa"
                        className="w-full px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white rounded-lg font-medium transition-all duration-200 text-center block"
                      >
                        Debes de completar el perfil
                      </Link>
                    )}
                    {InfoCompany.complete_profile_status == 1 && (
                      <button className="w-full px-6 py-3 bg-yellow-600 text-white rounded-lg font-medium cursor-not-allowed opacity-75">
                        En Proceso de Validación
                      </button>
                    )}
                    {InfoCompany.complete_profile_status == 4 && (
                      <button className="w-full px-6 py-3 bg-red-600 text-white rounded-lg font-medium cursor-not-allowed opacity-75">
                        Perfil rechazado
                      </button>
                    )}
                  </div>

                  <div className="mt-8 flex justify-center gap-4">
                    {InfoCompany.Facebook_link != null && (
                      <a href={InfoCompany.Facebook_link} target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon
                          className="text-slate-400 hover:text-blue-400 transition-colors"
                          size="lg"
                          icon={faFacebookSquare}
                        />
                      </a>
                    )}
                    {InfoCompany.Twitter_link != null && (
                      <a href={InfoCompany.Twitter_link} target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon
                          className="text-slate-400 hover:text-blue-400 transition-colors"
                          size="lg"
                          icon={faTwitterSquare}
                        />
                      </a>
                    )}
                    {InfoCompany.Instagram_link != null && (
                      <a href={InfoCompany.Instagram_link} target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon
                          className="text-slate-400 hover:text-pink-400 transition-colors"
                          size="lg"
                          icon={faInstagramSquare}
                        />
                      </a>
                    )}
                    {InfoCompany.Linkedin_link != null && (
                      <a href={InfoCompany.Linkedin_link} target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon
                          className="text-slate-400 hover:text-blue-400 transition-colors"
                          size="lg"
                          icon={faLinkedin}
                        />
                      </a>
                    )}
                  </div>
                </div>
              </div>

              <div className="lg:col-span-8">
                <div className="flex justify-end gap-3 mb-6">
                  {(InfoCompany.complete_profile_status == 3 ||
                    InfoCompany.complete_profile_status == 2 ||
                    InfoCompany.complete_profile_status == 1) && (
                      <Link to="/editar-perfil-empresa">
                        <button className="px-4 py-2 bg-slate-700/50 hover:bg-slate-600/50 text-white rounded-lg border border-slate-600/50 transition-all duration-200 flex items-center gap-2">
                          <span>✏️</span> Editar perfil
                        </button>
                      </Link>
                    )}
                  {InfoCompany.complete_profile_status == 3 && (
                    <div className="relative">
                      <button
                        className="px-4 py-2 bg-slate-700/50 hover:bg-slate-600/50 text-white rounded-lg border border-slate-600/50 transition-all duration-200 flex items-center gap-2"
                        onClick={() => setdropdownOpen(!dropdownOpen)}
                      >
                        Ver más
                        <FontAwesomeIcon className="text-white" icon={faChevronDown} />
                      </button>
                      <div
                        className={`${dropdownOpen ? "opacity-100 visible" : "invisible opacity-0"} absolute right-0 mt-2 w-56 bg-slate-800 border border-slate-700 rounded-lg shadow-xl z-10 transition-all duration-200`}
                      >
                        <ul className="py-2">
                          <li>
                            <Link
                              to="/perfil-pago"
                              className="px-4 py-3 hover:bg-slate-700 flex items-center text-white transition-colors"
                            >
                              <FontAwesomeIcon className="text-slate-400 mr-3" icon={faCreditCard} /> Perfil de pago
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/historialFacturacion"
                              className="px-4 py-3 hover:bg-slate-700 flex items-center text-white transition-colors"
                            >
                              <FontAwesomeIcon className="text-slate-400 mr-3" icon={faClockRotateLeft} /> Historial de
                              pago
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/DetallesSuscripcion"
                              className="px-4 py-3 hover:bg-slate-700 flex items-center text-white transition-colors"
                            >
                              <FontAwesomeIcon className="text-slate-400 mr-3" icon={faCheckToSlot} /> Detalles de
                              suscripción
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-slate-800/50 backdrop-blur-sm rounded-xl p-6 border border-slate-700/50 hover:border-slate-600/50 transition-all duration-200 flex items-center">
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 bg-slate-700/50 rounded-lg flex items-center justify-center">
                        <FontAwesomeIcon className="text-slate-300 text-xl" icon={faBars} />
                      </div>
                      <div className="flex-1">
                        <h3 className="text-white font-semibold mb-1">Estado actual</h3>
                        <p className="text-orange-400 font-medium">
                          {InfoCompany.complete_profile_status == 3 && "Completo"}
                          {InfoCompany.complete_profile_status == 2 && "Incompleto"}
                          {InfoCompany.complete_profile_status == 1 && "En validación"}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-slate-800/50 backdrop-blur-sm rounded-xl p-6 border border-slate-700/50 hover:border-slate-600/50 transition-all duration-200">
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 bg-slate-700/50 rounded-lg flex items-center justify-center">
                        <FontAwesomeIcon className="text-slate-300 text-xl" icon={faChartLine} />
                      </div>
                      <div className="flex-1">
                        <h3 className="text-white font-semibold mb-1">Actividad económica</h3>
                        <p className="text-blue-400 font-medium">{InfoCompany.activity_id || "No especificada"}</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-slate-800/50 backdrop-blur-sm rounded-xl p-6 border border-slate-700/50 hover:border-slate-600/50 transition-all duration-200">
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 bg-slate-700/50 rounded-lg flex items-center justify-center">
                        <FontAwesomeIcon className="text-slate-300 text-xl" icon={faPhone} />
                      </div>
                      <div className="flex-1">
                        <h3 className="text-white font-semibold mb-1">Teléfono principal</h3>
                        <p className="text-slate-300 font-medium">{InfoCompany.phone || "No especificado"}</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-slate-800/50 backdrop-blur-sm rounded-xl p-6 border border-slate-700/50 hover:border-slate-600/50 transition-all duration-200">
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 bg-slate-700/50 rounded-lg flex items-center justify-center">
                        <FontAwesomeIcon className="text-slate-300 text-xl" icon={faPhone} />
                      </div>
                      <div className="flex-1">
                        <h3 className="text-white font-semibold mb-1">Teléfono secundario</h3>
                        <p className="text-slate-300 font-medium">{InfoCompany.secondary_phone || "No especificado"}</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-slate-800/50 backdrop-blur-sm rounded-xl p-6 border border-slate-700/50 hover:border-slate-600/50 transition-all duration-200 flex items-center">
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 bg-slate-700/50 rounded-lg flex items-center justify-center">
                        <FontAwesomeIcon className="text-slate-300 text-xl" icon={faEnvelope} />
                      </div>
                      <div className="flex-1 min-w-0">
                        <h3 className="text-white font-semibold mb-1">Email</h3>
                        <p className="text-slate-300 font-medium truncate">{InfoCompany.email}</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-slate-800/50 backdrop-blur-sm rounded-xl p-6 border border-slate-700/50 hover:border-slate-600/50 transition-all duration-200">
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 bg-slate-700/50 rounded-lg flex items-center justify-center">
                        <FontAwesomeIcon className="text-slate-300 text-xl" icon={faLocationDot} />
                      </div>
                      <div className="flex-1">
                        <h3 className="text-white font-semibold mb-1">Dirección</h3>
                        <p className="text-slate-300 font-medium">{InfoCompany.direction || "No especificada"}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default CreacionProfileFreelancer
